export default {
    notAllowProperty: {
        device: 'device'
    }
};
